import { DomSanitizer } from '@angular/platform-browser';
import { DeviceDetectorService } from '../../../util/device-detector/device-detector.service';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewRef } from '@angular/core';
import { ClientBook } from '../../../PODO/clientBook';
import { ModalController } from '@ionic/angular';
import { ContactSupportComponent } from '../../../components/contact-support/contact-support.component';
import { ContextmenuService } from '../../services/contextmenu/contextmenu.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-book-header',
  templateUrl: './book-header.component.html',
  styleUrls: ['./book-header.component.scss'],
})
export class BookHeaderComponent implements OnInit, OnDestroy {
  innerWidth: any;

  @Input() zoom: number = 0;
  @Output() zoomIn = new EventEmitter<boolean>();
  @Output() zoomOut = new EventEmitter<boolean>();

  @Input() previousPageButton: boolean = false;
  @Output() onNavigate = new EventEmitter<any>();

  @Input() bookCoverSrc: string | undefined;
  @Input() bookTitle: string | undefined;
  @Input() tableOfContentsOpened: boolean | undefined;
  @Input() book: ClientBook | undefined;
  @Input() selectedChapter: string = '';
  @Output() onMobileWidth = new EventEmitter<any>();
  @Output() onToggleTableOfContents = new EventEmitter<any>();
  @Output() openBookLibrary = new EventEmitter<any>();
  @Output() onToggleSearch = new EventEmitter<any>();
  @Output() onToggleNoteOverview = new EventEmitter<any>();

  public isHighlightingEnabled: boolean = false;
  @Output('toggleHighlighting') toggleHighlightingEmitter = new EventEmitter<boolean>();

  public noteIcon = false;
  public activatedView = 'book';

  private subscriptions: Subscription[] = [];

  public contrastColor = getComputedStyle(document.documentElement).getPropertyValue('--book-contextMenu-color4');

  constructor(
    public sanitizer: DomSanitizer,
    public deviceDetector: DeviceDetectorService,
    private changeDetectorRef: ChangeDetectorRef,
    private modalCtrl: ModalController,
    public contextMenuService: ContextmenuService
  ) {
    this.subscriptions.push(
      contextMenuService.color$.subscribe(() => this.notifyChanges())
    );
  }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  // getTrustHtml(selectedChapter: any) {
  //   return this.sanitizer.bypassSecurityTrustHtml(selectedChapter);
  // }

  onZoomIn(event: any) {
    this.zoomIn.emit(event);
  }
  onZoomOut(event: any) {
    this.zoomOut.emit(event);
  }

  goToBookLibrary3() {
    this.openBookLibrary.emit(true);
  }

  public async openContactSupport() {
    let cssClass = this.deviceDetector.isDesktop() ? 'ion-main-modal' : 'ion-main-modal-mobile';
    const popover = await this.modalCtrl.create({
      component: ContactSupportComponent,
      cssClass: cssClass,
    });
    return await popover.present();
  }

  tableOfContentView() {
    this.onToggleTableOfContents.emit(!this.tableOfContentsOpened);
  }

  goToPrevPage() {
    this.onNavigate.emit();
  }

  public notifyChanges() {
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  toggleHighlighting() {
    this.isHighlightingEnabled = !this.isHighlightingEnabled;
    this.toggleHighlightingEmitter.emit(this.isHighlightingEnabled);
    this.notifyChanges();
  }
}
